let lenis = null;

export const setLenis = (l) => {
  lenis = l;
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenis) {
    lenis.scrollTo(el, { offset: -90, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
